import { Action, createReducer, on } from '@ngrx/store';
import { ISetupStatusResponse } from '../../todos/models/setup-status.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  clearLegalEntitiesForUserSuccess,
  loadLegalEntitiesForUserFailure,
  loadLegalEntitiesForUserRequest,
  loadLegalEntitiesForUserSuccess
} from '../actions/legal-entities-for-user.actions';

export const legalEntitiesForUserKey = 'loadLegalEntitiesForUser';

export interface LegalEntitiesForUserState {
  isLoading: boolean;
  loadLegalEntitiesForUserSuccess: ISetupStatusResponse;
  loadLegalEntitiesForUserFailure: IGenericError<ErrorResponse>;
}

export const initialState: LegalEntitiesForUserState = {
  isLoading: false,
  loadLegalEntitiesForUserSuccess: undefined,
  loadLegalEntitiesForUserFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region REGISTER
  on(loadLegalEntitiesForUserRequest, (state, action) => ({
    ...state,
    isLoading: true
  })),
  on(loadLegalEntitiesForUserSuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesForUserSuccess: action.response,
    isLoading: false
  })),
  on(loadLegalEntitiesForUserFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesForUserFailure: action.error,
    isLoading: false
  })),
  on(clearLegalEntitiesForUserSuccess, (state, action) => ({
    ...state,

    clear: undefined
  }))

  //#endregion
);

//#region LOGIN
export const getIsLegalEntitiesForUserLoading = (state: LegalEntitiesForUserState) => state.isLoading;
export const getLegalEntitiesForUserSuccess = (state: LegalEntitiesForUserState) => state.loadLegalEntitiesForUserSuccess;
export const getLegalEntitiesForUserFailure = (state: LegalEntitiesForUserState) => state.loadLegalEntitiesForUserFailure;
//#endregion
